




































import { Vue, Component } from "vue-property-decorator";
import ApiList from "@/components/integrations/ApiList.vue";
import WidgetList from "@/components/integrations/WidgetList.vue";

@Component({
  components: { ApiList, WidgetList }
})
export default class ApiKeysMain extends Vue {
  typeApi: string = "ApiList";
  data() {
    return {
      employee: undefined,
      appIdForDelete: undefined
    };
  }
}
